import { render, staticRenderFns } from "./DashboardExosDriveOffset.vue?vue&type=template&id=4bcabfb8&scoped=true&"
import script from "./DashboardExosDriveOffset.vue?vue&type=script&lang=ts&"
export * from "./DashboardExosDriveOffset.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardExosDriveOffset.vue?vue&type=style&index=0&id=4bcabfb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcabfb8",
  null
  
)

export default component.exports